import React, { useEffect, useState } from "react";
import CurrencyInput from "react-currency-input-field";

import { FaRegPenToSquare } from "react-icons/fa6";
import OurBankDetails from "../OurBankDetails";
import PaymentInfo from "@/components/forms/PaymentInfo";
import { useSelector } from "react-redux";

const ManualBankTransfer = () => {
  const [amount, setAmount] = useState(null);
  const [active, setActive] = useState(null);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [showDrawer, setShowDrawer] = useState(false);
  const [mobileBankTrans, setMobileBankTrans] = useState(false);
  const [passAmount, setPassAmount] = useState(null);
  const [loading, setLoading] = useState(false);

  const user = useSelector((state) => state.user.user);

  async function startBankTransfer(e) {
    e.preventDefault();
    setPassAmount(amount);
    setOpen(true);
    setMobileBankTrans(false);
    // setOpenMessage(true);
    setActive(null);
  }

  useEffect(() => {
    if (!open) {
      setAmount(null);
    }
  }, [open]);

  // console.log(passAmount);

  return (
    <div>
      <div className="dark:bg-darkInput flex flex-col justify-between rounded-[20px] p-5 shadow lg:col-span-1">
        <h2 className="text-xl font-bold text-gray-900 dark:text-white">
          Manual Bank Transfer
        </h2>
        <p className="pt-2 text-[0.9em] opacity-70">
          Transfer to our account number and we will credit your wallet as soon
          the transaction is confirmed{" "}
          <span className="text-primary font-bold">Charges ₦0</span>
        </p>
        <form onSubmit={startBankTransfer} className="mt-4 space-y-2.5">
          <div className="mt-1 flex flex-col">
            <div className="dark:border-darkBorder dark:bg-darkInput flex items-center gap-x-3 rounded-xl border bg-gray-50 p-2 py-2.5">
              <CurrencyInput
                name="amount"
                placeholder="Input amount (₦)"
                value={amount}
                onValueChange={(e) => setAmount(e)}
                className="w-full border-none bg-transparent text-sm outline-none dark:text-white"
                required
                prefix="₦ "
              />
            </div>

            {error && (
              <span className="py-2 text-sm font-medium text-red-500 md:text-xs">
                {error}
              </span>
            )}
          </div>

          <button
            className={`bg-primary mt-3 w-full rounded-xl p-2 font-medium text-white ${
              loading && "opacity-65"
            }`}
            disabled={loading}
            type="submit"
          >
            {loading ? "Processing..." : "Proceed"}
          </button>
        </form>

        <p
          onClick={() => {
            setOpen(false);
            setShowDrawer(true);
          }}
          className="text-primary bg-primary/20 mt-2 flex w-full cursor-pointer items-center gap-2 rounded-lg px-3 py-1 text-xs font-semibold lg:text-sm"
        >
          <FaRegPenToSquare size={20} className="" />{" "}
          <span className="flex-1">
            Click here and fill out the payment details form after transfer
          </span>
        </p>
      </div>

      <OurBankDetails
        open={open}
        setOpen={setOpen}
        user={user}
        amount={amount}
        showDrawer={showDrawer}
        setShowDrawer={setShowDrawer}
        setAmount={setAmount}
      />

      {showDrawer && (
        <PaymentInfo
          onClose={() => setShowDrawer(false)}
          initialAmount={passAmount}
        />
      )}
    </div>
  );
};

export default ManualBankTransfer;
